import { render, staticRenderFns } from "./AlertMessage.vue?vue&type=template&id=7097e93d"
import script from "./AlertMessage.vue?vue&type=script&lang=js"
export * from "./AlertMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7097e93d')) {
      api.createRecord('7097e93d', component.options)
    } else {
      api.reload('7097e93d', component.options)
    }
    module.hot.accept("./AlertMessage.vue?vue&type=template&id=7097e93d", function () {
      api.rerender('7097e93d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/messages/AlertMessage.vue"
export default component.exports